export enum PublicProfileStatusEnum {
  Active = 'active',
  Unverified = 'unverified',
  InActive = 'inActive',
}
